import { useQuery } from "@tanstack/react-query";
import type { components } from "../types/api";
import { apiFetch } from "../lib/api";

export type Me = components["schemas"]["UserResponse"];

export const meQuery = {
  queryKey: ["me"] as const,
  queryFn: () => apiFetch<Me>("/api/auth/me"),
};

export function useAuth() {
  const { data, isLoading, error } = useQuery({
    ...meQuery,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
  return { user: data, isLoading, error };
}
